import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useConnectAccountPopup } from 'components/Onboarding/useConnectAccountPopup'
import { InitiateOauthTrigger } from 'components/ConnectIntegrationTrigger/InitiateOauthTrigger'
import { Button } from 'blaze-ui/Button'
import { extractProfileInfo } from 'components/ExternalIntegrationSelect/utils'
import Avatar from 'common/Avatar/Avatar'
import { getInitials } from 'utils'
import Silhouette from 'components/Previews/InstagramPreview/silhouette.jpg'
import Styles from '../QuestionnairePanel.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { PlatformIcon } from 'screens/ScheduledPosts/PlatformIcon'

const SOCIAL_PLATFORMS = [
  { provider: ExternalIntegrationEnum.Instagram, label: 'Instagram' },
  { provider: ExternalIntegrationEnum.Facebook, label: 'Facebook' },
  { provider: ExternalIntegrationEnum.LinkedIn, label: 'LinkedIn' },
  { provider: ExternalIntegrationEnum.X, label: 'X / Twitter' },
  { provider: ExternalIntegrationEnum.GoogleBusinessProfile, label: 'Google Business' },
] as const

export const SocialAccountsStep = () => {
  const { getIntegration } = useExternalIntegrations()
  const { connect } = useConnectAccountPopup({ showToast: true })

  return (
    <>
      <div className={Styles.socialList}>
        {SOCIAL_PLATFORMS.map((platform) => {
          const integration = getIntegration(platform.provider)
          const isConnected = !!integration
          return (
            <div key={platform.provider} className={Styles.socialRow}>
              <div className={Styles.socialRowLeft}>
                <PlatformIcon isBrand platform={platform.provider} size={24} />
                <Text>{platform.label}</Text>
              </div>
              {isConnected && integration ? (
                <div className={Styles.connectedAccount}>
                  <Avatar
                    size={24}
                    label={getInitials(extractProfileInfo(integration).name)}
                    url={extractProfileInfo(integration).avatar || Silhouette}
                  />
                  <span className={Styles.connectedAccountName}>{extractProfileInfo(integration).name}</span>
                </div>
              ) : (
                <InitiateOauthTrigger provider={platform.provider} popUp onInitiatedOauth={connect}>
                  <Button variant="secondary" size="lg" className={Styles.socialConnectButton}>
                    Connect
                  </Button>
                </InitiateOauthTrigger>
              )}
            </div>
          )
        })}
      </div>
    </>
  )
}
